import React from "react";

const RefundPolicy = () => {
  return (
    <div className="cmnTermsPage">
      <div className="cmnTermsDiv">
        <h1>Cancellation and Refund</h1>
        <div style={{ padding: "0 20px" }}>
          <p className="cmnTermsContent">
            <p>
              {"   "}
              We do not offer any cancellations or Refunds to our customers for
              the use of our services. Please contact the Customer Support Team
              for any further queries or information.
            </p>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
